import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ArrowRight } from 'lucide-react';
const FAQS = [{
  q: 'Can I lease on with FSG?',
  a: 'Yes. Owner-operators can lease on with FSG for dispatch support, clear communication, and a compliance-first carrier. Apply to lease on to start the conversation.'
}, {
  q: 'Do I need my own authority?',
  a: 'Not always. You can run on your own authority with our dispatch support, or you can lease on with FSG. Both paths are available.'
}, {
  q: 'What can I expect weekly?',
  a: 'Weekly revenue is market-dependent and there are no guarantees. It depends on equipment, lanes, market conditions, availability, and how you run. FSG works to protect your RPM where possible.'
}, {
  q: 'What kind of freight do you usually run?',
  a: 'It varies by lane, equipment, and market conditions. FSG uses US freight market expertise and broker relationships to find solid available options.'
}, {
  q: 'What lanes do you run?',
  a: 'Lanes vary by your location and equipment. FSG plans around your preferences and where the freight is moving.'
}, {
  q: 'Do you force dispatch?',
  a: 'No. FSG presents load options and you choose which loads you accept. You stay in control of your truck.'
}, {
  q: 'Do you help with trailer rental?',
  a: 'Reach out about trailer rental options and setup, and FSG will help point you in the right direction.'
}, {
  q: 'What equipment do I need?',
  a: 'It depends on the freight you want to run. Reach out with your equipment details and FSG will help match you to the right work.'
}, {
  q: 'How fast can I start?',
  a: 'Once your documents and setup are complete, FSG works to get you moving quickly. Cleaner onboarding means fewer delays before the truck starts running.'
}, {
  q: 'Who handles broker calls and paperwork?',
  a: 'FSG handles broker calls, rate cons, paperwork, billing, and back-office follow-through with clear communication so you can focus on driving.'
}, {
  q: 'Can FSG help with insurance, registration, or compliance?',
  a: 'Yes. FSG provides compliance and back-office support, including broker-ready carrier operations and handoffs where appropriate.'
}, {
  q: 'Why 7% instead of a cheaper dispatcher?',
  a: 'FSG provides a full operating layer — US-based dispatch support, clear communication, broker-ready operations, and complete paperwork and billing follow-through — not just load booking.'
}];
export function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  // Split FAQs into two columns for desktop
  const midPoint = Math.ceil(FAQS.length / 2);
  const leftCol = FAQS.slice(0, midPoint);
  const rightCol = FAQS.slice(midPoint);
  const renderFaq = (faq: (typeof FAQS)[0], i: number, offset: number = 0) => {
    const actualIndex = i + offset;
    return <div key={actualIndex} className="border border-steel rounded-sm overflow-hidden bg-white" data-id="element-158">
        <button className="w-full px-5 py-4 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" onClick={() => setOpenIndex(openIndex === actualIndex ? null : actualIndex)} aria-expanded={openIndex === actualIndex} aria-controls={`faq-answer-${actualIndex}`} data-id="element-159">
          <span className="font-bold text-navy pr-4 text-sm md:text-base" data-id="element-160">
            {faq.q}
          </span>
          <ChevronDown className={`w-5 h-5 text-navy/50 shrink-0 transition-transform duration-200 ${openIndex === actualIndex ? 'rotate-180' : ''}`} data-id="element-161" />
        </button>
        <div id={`faq-answer-${actualIndex}`} className={`px-5 overflow-hidden transition-all duration-200 ease-in-out ${openIndex === actualIndex ? 'max-h-60 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-162">
          <p className="text-body text-sm md:text-base font-medium leading-relaxed" data-id="element-163">
            {faq.a}
          </p>
        </div>
      </div>;
  };
  return <section id="faq" className="py-12 lg:py-16 bg-off-white" data-id="element-164">
      <div className="container-custom max-w-6xl" data-id="element-165">
        <div className="text-center mb-10" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-black text-navy mb-3 tracking-tight" data-id="element-167">
            Questions Drivers and Owner-Operators Ask First
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 items-start" data-id="element-168">
          <div className="space-y-4" data-id="element-169">
            {leftCol.map((faq, i) => renderFaq(faq, i, 0))}
          </div>
          <div className="space-y-4" data-id="element-170">
            {rightCol.map((faq, i) => renderFaq(faq, i, midPoint))}
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-171">
          <Link to="/faq" className="inline-flex items-center gap-2 font-bold text-red hover:text-red-700 transition-colors uppercase tracking-wider text-sm" data-id="element-172">
            View All Questions
            <ArrowRight className="w-4 h-4" data-id="element-173" />
          </Link>
        </div>
      </div>
    </section>;
}